import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { Button, Icon } from "semantic-ui-react";

import styles from "./styles.module.css";
import "./styles.module.css";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { ErrorMessage, Form, Formik } from "formik";
import { authSchema } from "../../../../../app/common/validation/registration";
import {
  AnnualTurnover,
  EstablishedYears,
  FirmSize,
  PercentTotalAnnualTurnOver,
} from "../../../../../app/models/user";
import { ReactComponent as PlaySvg } from "../../../../../assets/play.svg";

const BorderLinearProgress = styled(LinearProgress)(
  ({ theme, valueBuffer }) => ({
    height: 4,
    borderRadius: 5,
    width: `${valueBuffer}%`,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#32c36c" : "#308fe8",
    },
    // [`&.${linearProgressClasses.buffer}`]: {
    //   width: valueBuffer,
    // },
  })
);

const ThirdStep = (props: any) => {
  const { nextStep, setScoreField, scoreField } = props;
  return (
    <>
      <div style={{ marginTop: "1px" }}>
        <Box sx={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingRight: "5%",
              fontSize: "9px",
              fontWeight: "thin",
              color: "#828282",
            }}
          >
            Step 1 of 3
          </div>
          <BorderLinearProgress
            variant="determinate"
            value={33}
            valueBuffer={95}
          />
        </Box>
      </div>
      <div className={styles.header}>Vendor Checklist</div>
      <Formik
        initialValues={{ email: "", password: "", error: null }}
        validationSchema={authSchema.register}
        onSubmit={() => console.log("")}
      >
        {({ handleSubmit, isSubmitting, errors, isValid, dirty }) => (
          <Form
            className={"ui form " + styles.form}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Years Established
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="years"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Over 5 years"
                    control={<Radio />}
                    label="Over 5 years"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        establishedYears: EstablishedYears.OverFiveYears,
                      })
                    }
                  />
                  <FormControlLabel
                    value="2-5 Years"
                    control={<Radio />}
                    label="2-5 Years"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        establishedYears: EstablishedYears.OverTwoYears,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Less than 2 Years"
                    control={<Radio />}
                    label="Less than 2 Years"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        establishedYears: EstablishedYears.LessThanTwoYears,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Size of Firm (No. of People)
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="size"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Over 25"
                    control={<Radio />}
                    label="Over 25"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        firmSize: FirmSize.OverTwentyFive,
                      })
                    }
                  />
                  <FormControlLabel
                    value="10 - 15"
                    control={<Radio />}
                    label="10 - 15"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        firmSize: FirmSize.TenToTwenty,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Less than 10"
                    control={<Radio />}
                    label="Less than 10"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        firmSize: FirmSize.LessThanTen,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Annual Turnover
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="turnover"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Over 500m"
                    control={<Radio />}
                    label="Over 500m"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        annualTurnover: AnnualTurnover.OverFiveHundredMetre,
                      })
                    }
                  />
                  <FormControlLabel
                    value="101 - 500m"
                    control={<Radio />}
                    label="101 - 500m"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        annualTurnover:
                          AnnualTurnover.OneHundredAndOneToFiveHundredMetre,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Less than 100m"
                    control={<Radio />}
                    label="Less than 100m"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        annualTurnover: AnnualTurnover.LessThanHundredMetre,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Turnover of Solar Home Systems as a percentage of total annual
                  turnover
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="percentage"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Over 80%"
                    control={<Radio />}
                    label="Over 80%"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        percentTotalAnnualTurnOver:
                          PercentTotalAnnualTurnOver.OverEightyPercent,
                      })
                    }
                  />
                  <FormControlLabel
                    value="40 - 80%"
                    control={<Radio />}
                    label="40 - 80%"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        percentTotalAnnualTurnOver:
                          PercentTotalAnnualTurnOver.FortyToEightyPercent,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Less than 40%"
                    control={<Radio />}
                    label="Less than 40%"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        percentTotalAnnualTurnOver:
                          PercentTotalAnnualTurnOver.LessThanFortyPercent,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className={styles.next}>
              <Button
                positive
                className={styles.positive}
                onClick={() => nextStep()}
                type="button"
                disabled={
                  !scoreField.establishedYears ||
                  !scoreField.firmSize ||
                  !scoreField.annualTurnover ||
                  !scoreField.percentTotalAnnualTurnOver
                }
              >
                <div className={styles.button}>
                  <span>Continue</span>
                  <PlaySvg />
                </div>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ThirdStep;
